import React from 'react';
import { Form, Col, Row, Button, Spinner } from 'react-bootstrap';
import { Typeahead } from 'react-bootstrap-typeahead';
import Multiselect from 'multiselect-react-dropdown';
import { MultiSelect } from "react-multi-select-component";
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory, { PaginationProvider, PaginationListStandalone } from 'react-bootstrap-table2-paginator';
//import filterFactory from 'react-bootstrap-table2-filter';
import axios, { AxiosRequestConfig } from 'axios';
import moment from 'moment';
import { Constants } from "../../constants";
import SiteMenu from "../menu";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import '../../App.css';
import ReactGA from "react-ga4";

const columns = [
    {
        dataField: 'VisitDate',
        text: 'Date',
        formatter: dateFormat,
        headerStyle: (colum, colIndex) => {
            return { width: '120px', textAlign: 'center' };
        }
    },
    {
        dataField: 'BuildingName',
        text: 'Building',
        headerStyle: (colum, colIndex) => {
            return { width: '250px', textAlign: 'center' };
        }
    },
    {
        dataField: 'Address1',
        text: 'Address',
        headerStyle: (colum, colIndex) => {
            return { width: '150px', textAlign: 'center' };
        }
    },
    {
        dataField: 'VisitType',
        text: 'Service Type',
        headerStyle: (colum, colIndex) => {
            return { width: '200px', textAlign: 'center' };
        }
    },
    {
        dataField: 'ServiceCallID',
        text: 'Service Call ID',
        headerStyle: (colum, colIndex) => {
            return { width: '130px', textAlign: 'center' };
        }
    },
    {
        dataField: 'Technician',
        text: 'Technician',
        headerStyle: (colum, colIndex) => {
            return { width: '200px', textAlign: 'center' };
        }
    },
    {
        dataField: 'ServiceNotes',
        text: 'Service Notes',
        headerStyle: (colum, colIndex) => {
            return { textAlign: 'center' };
        }
    }];

function dateFormat(value, row, index) {
    return moment(value).format('MM/DD/YYYY');
}

class BuildingServiceViewAdmin extends React.Component {

    constructor(props) {
        super(props);

        let userExists = !(props.location.state == null || props.location.state.user == null);

        this.state = {
            user: userExists ? props.location.state.user : {},
            page: 1,
            visits: [],
            selected: [],
            totalSize: 0,
            sizePerPage: 20,
            buildings: [],
            selectedBuildings: [],
            selectedVisitTypes: [],
            startDate: '',
            endDate: '',
            visitType: '',
            loading: false,
            downloadingCSV: false,
            hasAccess: userExists ? props.location.state.hasAccess : false
        };
        this.handleTableChange = this.handleTableChange.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleSearchChange = this.handleSearchChange.bind(this);
        this.handleClear = this.handleClear.bind(this);
        this.handleFilterChange = this.handleFilterChange.bind(this);
        this.handleVisitTypeChange = this.handleVisitTypeChange.bind(this);
        this.downloadSelected = this.downloadSelected.bind(this);
        this.showButton = this.showButton.bind(this);
        this.downloadCSV = this.downloadCSV.bind(this);

        this.loadingSpinner = this.loadingSpinner.bind(this);

        this.visitType = React.createRef();
        this.startDate = React.createRef();
        this.endDate = React.createRef();
    }

    componentDidMount() {
    }

    loadingSpinner() {
        if (this.state.loading) {
            return <div style={{ display: 'flex', justifyContent: 'center', marginTop: 5 }}>
                <Spinner animation="border" role="status">
                    <span className="visually-hidden">Loading...</span>
                </Spinner>
            </div>;
        }
        else {
            return 'No records.';
        }
    };

    handleVisitTypeChange(event) {
        console.log(event);
        let selectedVisitTypeString = event.map((item) => {
            return item.value
        }).join(';');
        console.log(selectedVisitTypeString);
        this.setState({
            selectedVisitTypes: event,
            visitType: selectedVisitTypeString,
            page: 1
        }, () => this.handleTableChange("search", this.state));

        /*var visits = selected.map(function (sel) {
            return sel.value;
        }).join(';');
        this.setState({ visitType: visits }, function () {
            this.handleTableChange("search", this.state)
        });*/
    }

    handleClear() {
        this.startDate.current.value = "";
        this.endDate.current.value = "";

        this.setState({
            visits: [],
            selected: [],
            selectedVisitTypes: [],
            buildingSearchString: '',
            totalSize: 0,
            page: 1,
            visitType: '',
            startDate: '',
            endDate: ''
        }, () => this.handleTableChange("search", this.state));

    }

    handleSearch(event) {
        event.preventDefault();
        this.handleTableChange("search", this.state);
    }
    handleSearchChange(event) {
        this.setState({
            buildingSearchString: event.target.value
        });
    }

    handleFilterChange(event) {
        let input = this.state;
        input[event.target.name] = event.target.value;
        input.page = 1;
        this.setState({
            input
        }, function () {
            this.handleTableChange("search", this.state)
        });
    }

    handleTableChange = (type, { page, sizePerPage, sortField, sortOrder }) => {

        ReactGA.event({
            category: 'Search',
            action: 'Technician Building Service Log',
            label: 'Technician Building Service Log Search'
        });
        this.setState({
            loading: true,
            visits: [],
            page,
            sortOrder,
            sortField,
            sizePerPage
        },
            function () {

                axios.get(`${Constants.apiURL}/api/Order/GetSiteVisitsByBuilding`, {
                    params: {
                        user: this.state.user.username,
                        page: this.state.page,
                        pageSize: this.state.sizePerPage,
                        visitType: this.state.visitType,
                        buildingSearchString: this.state.buildingSearchString,
                        startDate: this.state.startDate,
                        endDate: this.state.endDate,
                        isAdmin: true
                    }
                }).then(response => {
                    console.log(response);
                    if (response.data) {
                        this.setState(() => ({
                            loading: false,
                            visits: JSON.parse(response.data.data),
                            totalSize: response.data.rowcount,
                            selected: []
                        }));
                    }
                }).catch((response) => {
                    if (response.response.status === 401) {
                        this.props.history.push({
                            pathname: '/'
                        });
                    }
                    // ? Show to user that request is failed
                    this.setState({ errors: [response] })
                    this.setState({ loading: false });
                    console.log('request failed', response)
                });
            });
    }

    showCSVButton() {
        if (this.state.downloadingCSV) {
            return <Button style={{ backgroundColor: '#1F419B' }} variant="primary" type="submit">
                <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true" />
                <span className="visually-hidden">Downloading...</span>
            </Button>
        }
        else {
            return <Button style={{ backgroundColor: '#1F419B' }} variant="primary" type="submit" onClick={this.downloadCSV}>
                Export as CSV
            </Button>
        }
    }

    showButton() {
        if (this.state.loading) {
            return <Button style={{ marginLeft: '10px', backgroundColor: '#1F419B' }} variant="primary" type="submit">
                <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true" />
                <span className="visually-hidden">Loading...</span>
            </Button>
        }
        else {
            return <Button style={{ marginLeft: '10px', backgroundColor: '#1F419B' }} variant="primary" type="submit" onClick={this.downloadSelected}>
                Download Selected
            </Button>
        }
    }

    downloadSelected(event) {

        this.setState({ loading: true });
        axios.post(`${Constants.apiURL}/api/Order/DownloadSiteVisits`, {
            user: this.state.user.username,
            visits: this.state.selected
        }, {
            'headers': {
                'content-type': 'application/json'
            },
            responseType: 'blob'
        }).then(response => {
            console.log(response);
            this.setState({ loading: false });
            if (response.data) {
                let blob = new Blob([response.data], { type: 'application/zip' }),
                    downloadUrl = window.URL.createObjectURL(blob),
                    filename = "",
                    disposition = response.headers["content-disposition"];
                console.log(disposition);

                if (disposition && disposition.indexOf("attachment") !== -1) {
                    let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/,
                        matches = filenameRegex.exec(disposition);

                    if (matches != null && matches[1]) {
                        filename = matches[1].replace(/['"]/g, "");
                    }
                }
                else {
                    alert('We are unable to locate the selected document(s). Please email us at clientportal@boland.com for help with this issue.');
                    return;
                }

                let a = document.createElement("a");
                if (typeof a.download === "undefined") {
                    window.location.href = downloadUrl;
                } else {
                    a.href = downloadUrl;
                    a.download = filename;
                    document.body.appendChild(a);
                    a.click();
                }
                downloadUrl.revokeObjectURL();
            }
        }).catch((response) => {
            // ? Show to user that request is failed
            this.setState({ errors: [response] })
            this.setState({ loading: false });
            console.log('request failed', response)
        });
    }

    downloadCSV(event) {

        if (this.state.totalSize > 20000) {
            alert('Attempted to export too many records. The limit is 20,000.');
            return;
        }
        this.setState({ downloadingCSV: true });
        axios.get(`${Constants.apiURL}/api/Order/DownloadBuildingSiteVisitReport`, {
            params: {
                user: this.state.user.username,
                visitType: this.state.visitType,
                buildingSearchString: this.state.buildingSearchString,
                startDate: this.state.startDate,
                endDate: this.state.endDate,
                isAdmin: true
            },
            responseType: 'blob'
        }).then(response => {
            console.log(response);
            this.setState({ downloadingCSV: false });
            if (response.data) {
                if (response.data == 'No files found.') return;
                let blob = new Blob([response.data], { type: 'text/csv' }),
                    downloadUrl = window.URL.createObjectURL(blob),
                    filename = "",
                    disposition = response.headers["content-disposition"];

                if (disposition && disposition.indexOf("attachment") !== -1) {
                    let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/,
                        matches = filenameRegex.exec(disposition);

                    if (matches != null && matches[1]) {
                        filename = matches[1].replace(/['"]/g, "");
                    }
                }
                else {
                    alert('We are unable to locate the selected document(s). Please email us at clientportal@boland.com for help with this issue.');
                    return;
                }

                let a = document.createElement("a");
                if (typeof a.download === "undefined") {
                    window.location.href = downloadUrl;
                } else {
                    a.href = downloadUrl;
                    a.download = filename;
                    document.body.appendChild(a);
                    a.click();
                }
                downloadUrl.revokeObjectURL();
            }
        }).catch((response) => {
            // ? Show to user that request is failed
            this.setState({ errors: [response] })
            this.setState({ downloadingCSV: false });
            console.log('request failed', response)
        });
    }

    handleSelect = (row, isSelect) => {
        if (isSelect) {
            this.setState(() => ({
                selected: [...this.state.selected, row]
            }));
        } else {
            this.setState(() => ({
                selected: this.state.selected.filter(x => x !== row)
            }));
        }
    }

    handleSelectAll = (isSelect, rows) => {
        if (isSelect) {
            this.setState(() => ({
                selected: rows
            }));
        } else {
            this.setState(() => ({
                selected: []
            }));
        }
    }

    render() {
        const selectRow = {
            mode: 'checkbox',
            clickToSelect: true,
            onSelect: this.handleSelect,
            onSelectAll: this.handleSelectAll
        };
        const { data, totalSize, page, sizePerPage, selectedVisitTypes } = this.state;
        const pagination = {
            custom: true,
            totalSize: totalSize,
            page: page,
            sizePerPage: sizePerPage
        };
        const customValueRenderer = (selected, _options) => {
            return selected.length
                ? selected.map(({ label }) => label + ", ").join('').replace(/, $/, '')
                : "Filter by building";
        };
        const customValueRendererVisitTypes = (selected, _options) => {
            return selected.length
                ? selected.map(({ label }) => label + ", ").join('').replace(/, $/, '')
                : "Filter by visit type";
        };
        return (
            <div class="building_view">
                <SiteMenu user={this.state.user} currentPage='buildingServiceView' />
                <p hidden={this.state.hasAccess}>No access.</p>
                <div hidden={!this.state.hasAccess}>
                    <Form onSubmit={this.handleSearch} className="mb-3">

                        <Form.Group as={Row} controlId="searchForm" style={{ padding: '10px 10px 0px 10px', justifyContent: 'right' }}>
                            <Col md="auto" sm="auto" xs="auto">
                                <Form.Label class='padding_left_zero_xs' style={{ paddingBottom: 0, marginBottom: 0, verticalAlign: 'middle', fontWeight: 'bold', fontSize: '21px', color: '#1F419B' }}>VIRTUAL LOCK BOX</Form.Label>
                            </Col>
                            <Col width="100%">
                            </Col>
                            <Col md="auto">
                                <Form.Control value={this.state.buildingSearchString} type="input" size="sm" onChange={this.handleSearchChange} placeholder="Search by building name or address..." style={{ minWidth: '300px' }} />

                            </Col>
                            <Col md="auto">
                                <MultiSelect
                                    style={{ minWidth: '300px' }}
                                    className="multiselect sm"
                                    options={[
                                        { Id: 1, value: 'CONTRACT MAINTENANCE', label: 'CONTRACT MAINTENANCE' },
                                        { Id: 2, value: 'NEW EQUIPMENT STARTUP & WARRANTY', label: 'NEW EQUIPMENT STARTUP & WARRANTY' },
                                        { Id: 3, value: 'QUOTED SERVICE', label: 'QUOTED SERVICE' },
                                        { Id: 4, value: 'SERVICE CALL', label: 'SERVICE CALL' },
                                        { Id: 5, value: 'PRODUCT DEFECT', label: 'PRODUCT DEFECT' },
                                        { Id: 6, value: 'TRANE FACTORY WARRANTY', label: 'TRANE FACTORY WARRANTY' }
                                    ]}
                                    onChange={this.handleVisitTypeChange}
                                    labelledBy="Select"
                                    value={selectedVisitTypes}
                                    valueRenderer={customValueRendererVisitTypes}
                                    hasSelectAll={false}
                                />
                            </Col>
                            <Col md={2} >
                                <Form.Group as={Row} className="mb-3" controlId="startDate" style={{}}>
                                    <Form.Label style={{ alignSelf: 'center', textAlign: 'right', padding: 0 }} column md={3} size="sm">Start Date</Form.Label>
                                    <Col md={9}>
                                        <Form.Control ref={this.startDate} size="sm" type="date" min={moment('2019-01-01').format('yyyy-MM-DD')} name="startDate" value={this.state.startDate} onChange={this.handleFilterChange}
                                        /*disabled={Object.keys(this.state.selectedBuilding).length == 0}*/ />
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-3" controlId="endDate">
                                    <Form.Label style={{ alignSelf: 'center', textAlign: 'right', padding: 0 }} column md={3} size="sm">End Date</Form.Label>
                                    <Col md={9}>
                                        <Form.Control ref={this.endDate} size="sm" type="date" min={moment('2019-01-01').format('yyyy-MM-DD')} name="endDate" value={this.state.endDate} onChange={this.handleFilterChange}
                                        /*disabled={Object.keys(this.state.selectedBuilding).length == 0}*/ />
                                    </Col></Form.Group>
                            </Col>
                            <Col md="auto" sm="auto" xs="auto" className="button_first" style={{ paddingLeft: 0 }}>
                                <Button style={{ backgroundColor: '#1F419B' }} type="submit" size="sm">
                                    Search
                                </Button>
                            </Col>
                            <Col md="auto" sm="auto" xs="auto" style={{ paddingLeft: 0 }}>
                                <Button size="sm" onClick={this.handleClear} variant="secondary" >
                                    Clear
                                </Button>
                            </Col>
                        </Form.Group>
                    </Form>
                    <PaginationProvider pagination={paginationFactory(pagination)}>
                        {({
                            paginationProps,
                            paginationTableProps
                        }) => (
                            <div>
                                <BootstrapTable
                                    bootstrap4
                                    remote
                                    keyField="Id"
                                    selectRow={selectRow}
                                    wrapperClasses="building_admin_table table-responsive"
                                    data={this.state.visits}
                                    columns={columns}
                                    onTableChange={this.handleTableChange}
                                    noDataIndication={() =>
                                        <Form.Label style={{ fontSize: '16px', fontStyle: 'italic' }}>
                                            Service notes for this building have not yet been completed.
                                        </Form.Label>}
                                    striped
                                    hover
                                    {...paginationTableProps}
                                />
                                <Form.Group as={Row} controlId="bolandButtons" style={{ padding: '0px 0px 0px 0px', marginRight: 0 }}>
                                    <Col md={{ span: 'auto', order: 1 }} sm={{ span: 'auto', order: 1 }} xs={{ span: 'auto', order: 2 }}>
                                        {this.showButton()}
                                    </Col>
                                    {/*<Col md={{ span: 'auto', order: 2 }} sm={{ span: 'auto', order: 2 }} xs={{ span: 'auto', order: 3 }} style={{ paddingLeft: 0 }}>
                                        {this.showCSVButton()}
                                    </Col>*/}
                                    <Col width='100%' />
                                    <Col md={{ span: 'auto', order: 3 }} sm={{ span: 'auto', order: 3 }} xs={{ span: 12, order: 1 }}
                                        style={{ paddingRight: '10px' }} >
                                        <PaginationListStandalone
                                            {...paginationProps}
                                        />
                                    </Col>
                                </Form.Group>
                            </div>
                        )
                        }
                    </PaginationProvider>
                </div>
            </div>
        );
    }
}

export default BuildingServiceViewAdmin;